import type { Type } from '@angular/core';
import { ChangeDetectionStrategy, Component, effect, inject, ViewEncapsulation } from '@angular/core';
import { UiFeature } from '@hyundai/ng-common-lib';
import { Store } from '@ngrx/store';
import type { DialogRef } from '@pixelgenau/ngx-dialog';
import { DialogService } from '@pixelgenau/ngx-dialog';
import { firstValueFrom } from 'rxjs';
import { MainNavDialogTag } from './main-nav/main-nav.dialog';

@Component({
    template: '',
    selector: 'app-nav-wrapper',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [],
    standalone: true,
})
export class NavWrapperComponent {
    store = inject(Store);
    dialogService = inject(DialogService);
    showMenu = this.store.selectSignal(UiFeature.state.selectShowMenu);

    ref?: DialogRef<unknown, Type<unknown>>;

    openMenuEffect = effect(() => {
        this.ref?.close();
        if (this.showMenu()) this.openDialog();
    });

    async openDialog() {
        this.ref = await firstValueFrom(this.dialogService.openDialog(MainNavDialogTag));
    }
}
